/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Coordinates for manual place creation (fallback)
 * @export
 * @interface CreateStopDtoCoordinates
 */
export interface CreateStopDtoCoordinates {
    /**
     * 
     * @type {number}
     * @memberof CreateStopDtoCoordinates
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStopDtoCoordinates
     */
    longitude?: number;
}

/**
 * Check if a given object implements the CreateStopDtoCoordinates interface.
 */
export function instanceOfCreateStopDtoCoordinates(value: object): value is CreateStopDtoCoordinates {
    return true;
}

export function CreateStopDtoCoordinatesFromJSON(json: any): CreateStopDtoCoordinates {
    return CreateStopDtoCoordinatesFromJSONTyped(json, false);
}

export function CreateStopDtoCoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStopDtoCoordinates {
    if (json == null) {
        return json;
    }
    return {
        
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

  export function CreateStopDtoCoordinatesToJSON(json: any): CreateStopDtoCoordinates {
      return CreateStopDtoCoordinatesToJSONTyped(json, false);
  }

  export function CreateStopDtoCoordinatesToJSONTyped(value?: CreateStopDtoCoordinates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

